import './../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import * as React from 'react';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import RestService from '../RestService';
import SegmentInsertForm from './SegmentInsertForm';
import Snackbar from 'material-ui/Snackbar';

interface State {
    page: number;
    processedTable: any[];
    option: any;
    openSnackBar:any;
    snackBarMessage:any;
}

class Segments extends React.Component<{}, State> {
    constructor() {
        super();
        this.state = {
            page: 1,
            processedTable: [],
            option: {
                onAddRow: this.handleInsertedRow,
                insertModal: this.createCustomModal,
            },
            openSnackBar: false,
            snackBarMessage:'',
        };
    }

    componentWillMount() {
        this.getSegments();
    }

    getSegments = () => {
        RestService.getSegments((SegmentTable: any[]) => {
            this.parseData(SegmentTable);
        });
    }

    parseData = (tableData:any) => {
        let segList=[];
        for(let seg in tableData){
            segList[seg]=JSON.parse(JSON.stringify(tableData[seg]));
        }
        this.setState({
            ...this.state,
            processedTable: segList,
        });

    }

    getRandomCsid = () => {
        const min = Math.ceil(10);
        const max = Math.floor(10000000);
        return Math.floor(Math.random() * (max - min)) + min;
    }

    toJsonObject = (row:any) => {
        let startDate = Math.round(new Date().getTime() /1000);
        let randomCsid = this.getRandomCsid();

        let segmentSet = new Set(this.state.processedTable);
        while (segmentSet.has(randomCsid)) {
            randomCsid = this.getRandomCsid();
        }

        row['id'] = randomCsid;
        row['source'] = 'custom';
        row['createdAtInSecs'] = startDate;
        row['updatedAtInSecs'] = startDate;
        return row;
    }

    handleInsertedRow = (row:any) => {
        RestService.addSegment(
            this.toJsonObject(row),
            (response: any) => {
                this.getSegments();
            },
        );
    }

    handleClose = () => {
        this.setState({
            ...this.state,
            openSnackBar: false,
        });
    }

    createCustomModal = (onModalClose, onSave, columns, validateState : {}, ignoreEditable: boolean) => {
        return (
            <SegmentInsertForm
                onModalClose = {onModalClose}
                onSave= {onSave}
                columns = {columns}
                validateState = {validateState}
                ignoreEditable= {ignoreEditable}
            />
        );
    }

    render() {
        return (
            <div style={{ marginTop: '80px', width: '100%' }}>
                <BootstrapTable ref='table' data={this.state.processedTable} insertRow={ true } options={this.state.option} hover search={ { type: 'TextSearch'} } pagination={true}>
                    <TableHeaderColumn isKey={true} dataField='id' width='8%'>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='name' width='8%'>Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='displayName' width='8%'>Display Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='source' width='8%'>Source</TableHeaderColumn>
                    <TableHeaderColumn dataField='createdAtInSecs' width='8%'>createdAtInSecs</TableHeaderColumn>
                    <TableHeaderColumn dataField='updatedAtInSecs' width='8%'>updatedAtInSecs</TableHeaderColumn>
                </BootstrapTable>
            <Snackbar open={this.state.openSnackBar} message={this.state.snackBarMessage} onRequestClose={this.handleClose} autoHideDuration={2000} />
            </div>
        );
    }
}

export default Segments;



// WEBPACK FOOTER //
// ./src/components/Segments.tsx